import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export default function CapsuleIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <g
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M10.5 20.5a5 5 0 0 1-7-7l9-9a5 5 0 1 1 7 7l-9 9z" />
        <line x1="8" y1="8" x2="16" y2="16" />
      </g>
    </SvgIcon>
  );
}
